function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#90bae1"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.83 53l-1.9-3.65c-.027 0-.064.002-.109.007-.046.005-.116.007-.212.007h-1.238V53H15.73V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615s.602.604.807.991.308.822.308 1.306c0 .729-.169 1.349-.506 1.859a3.034 3.034 0 01-1.367 1.135L22.566 53H20.83zm-3.459-4.84h1.49c.2 0 .4-.034.602-.103.2-.068.383-.18.547-.335s.296-.371.396-.649c.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567-.046-.214-.139-.419-.28-.615s-.34-.36-.595-.492c-.256-.132-.593-.198-1.012-.198h-1.23v3.991zM31.891 42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121h7.67zM35.555 44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924h6.303v1.244h-4.635z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#c8bdb8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 13h6a1 1 0 100-2h-6a1 1 0 100 2zM12.5 18h9a1 1 0 100-2h-9a1 1 0 100 2zM25.5 18c.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.38-.37-1.04-.37-1.42 0-.181.19-.29.44-.29.71s.109.52.29.71c.189.18.45.29.71.29zM29.5 18h8a1 1 0 100-2h-8a1 1 0 100 2zM11.79 31.29c-.181.19-.29.44-.29.71s.109.52.29.71c.189.18.439.29.71.29.27 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.37-.37-1.05-.37-1.42 0zM24.5 31h-8a1 1 0 100 2h8a1 1 0 100-2zM41.5 18h2a1 1 0 100-2h-2a1 1 0 100 2zM12.5 23h22a1 1 0 100-2h-22a1 1 0 100 2zM43.5 21h-6a1 1 0 100 2h6a1 1 0 100-2zM12.5 28h4a1 1 0 100-2h-4a1 1 0 100 2zM30.5 26h-10a1 1 0 100 2h10a1 1 0 100-2zM43.5 26h-9a1 1 0 100 2h9a1 1 0 100-2z"
}));

var SvgRtf = function SvgRtf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgRtf;